<template>
<div v-if="this.$store.getters.Loaded" class="uk-flex  uk-position-top-right uk-position-fixed uk-position-z-index">
    <div class="uk-container-small uk-container-right ">
        <nav class="uk-navbar uk-navbar-container uk-margin uk-navbar-transparent uk-position-z-index uk-text-uppercase" uk-navbar>
            <div class="uk-navbar-right ">
                <a class="uk-navbar-toggle uk-navbar-toggle-animate uk-margin-right uk-margin-top uk-icon-button uk-width uk-button-primary" uk-navbar-toggle-icon href="#"></a>
                <div class="uk-navbar-dropdown uk-position-z-index-one uk-navbar-dropdown-width-2"  >
                    <ul class="uk-nav uk-navbar-dropdown-nav  ">
                        <hr class="uk-divider-small">
                            <li  v-if="this.$store.getters.GetBlock.navbar2">
                            <router-link href="#" uk-scroll class="  uk-menu-item uk-text-default" to="/">{{this.$store.getters.GetText.navbar.general[this.$store.getters.Lang]}}</router-link>
                        </li>
                        <hr class="uk-divider-small">
                            <li  v-if="this.$store.getters.GetBlock.navbar2">
                            <router-link href="#" uk-scroll class="  uk-menu-item uk-text-default" to="/more">{{this.$store.getters.GetText.navbar.aditional[this.$store.getters.Lang]}}</router-link>
                        </li>                         
                        <hr class="uk-divider-small">
                        <li v-if="this.$store.getters.GetAccess">                       
                            <a class="  uk-link-heading uk-menu-item" uk-scroll v-on:click="logout">{{this.$store.getters.GetText.navbar.logout[this.$store.getters.Lang]}}</a>
                        </li>
                        <hr class="uk-divider-small">
                        <!--hr class="uk-divider-small">
                        <li>
                            <a v-if="this.$store.getters.MultiLang" class=" uk-menu-item uk-text-default" uk-scroll v-on:click="this.$store.commit('CHANGE_Lang')">{{this.$store.getters.Lang}}</a>
                        </li-->
                    </ul>
                </div>
            </div>            
        </nav>
          
    </div>    
</div>
</template>
<script>

import api from '@/api'

export default {
  name: 'NavBarAdmin',  
  data(){    
    return{        
        editor: false        
    }    
  },
  beforeMount(){
    window.scrollTo(0, 0)
  },
  methods:{
    logout(){
        var $this=this
        this.$store.commit('SET_Loaded',false)
       api.post('api/auth/logout').then(res=>{
        if (res.status==200){
            localStorage.removeItem('access_token')
            this.$router.push({name:'home'})
            $this.$store.commit('SET_Loaded',true)
            $this.$store.commit('SET_ACCESS_DIR',false)
        }
       }) 
    }
  }
  }
</script>